// hasAccessDirective.js

import { computed } from 'vue';
import { GetUserData } from '~/constants/getters';

/**
 * Hides or disable an ui element based on binding.arg
 * Usability: v-has-access:hide="['admin']" or v-has-access:disabled="['admin']"
 * @param {HTMLElement} 'el' - current html element
 * @param {Object} 'binding' - values sent to the directive
 */

export default {
  mounted(el, binding) {
    const permissions = computed(() => binding.instance.$store.getters[`authStore/${GetUserData}`].permissions || {});

    const resource = binding.value.resource;
    const action = binding.value.resource_action;

    if (!resource || !action) {
      return;
    }

    const hasAccess = permissions.value[resource]?.[action] ?? false;

    if (!hasAccess) {
      if (binding.arg === 'hide') {
        el.style.display = 'none'; // Hide the element
      } else if (binding.arg === 'disabled') {
        el.style.pointerEvents = 'none'; // Disable the element
        el.style.opacity = '1';
        el.style.backgroundColor = 'transparent';
        el.style.border = '1px solid #e8e7e5';
      }
    }
  },
};
